'use strict'

import PhotoSwipe from 'photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import template from './photoswipe-template.html'
import 'photoswipe/dist/photoswipe.css'
import 'photoswipe/dist/default-skin/default-skin.css'
import images from '../../public/notebooks/images.json'

function createDOM (tmpl) {
  const temp = document.createElement('div')
  temp.innerHTML = tmpl
  return temp.firstElementChild
}

const notebooksContainer = document.querySelector('.griddex--notebooks')
const links = Array.prototype.slice.call(notebooksContainer.querySelectorAll('.griddex__link'))
const photoswipeEl = createDOM(template)
const options = {
  showHideOpacity: true,
  closeOnScroll: false,
  getThumbBoundsFn (index) {
    var thumbnail = links[index];
    const { top, left, width } = thumbnail.getBoundingClientRect()
    const pageYScroll = window.pageYOffset || document.documentElement.scrollTop
    return {
      y: top + pageYScroll,
      x: left,
      w: width
    }
  }
}

document.body.appendChild(photoswipeEl)
notebooksContainer.addEventListener('click', (event) => {
  const link = event.target.parentElement
  if (link.className.indexOf('griddex__link') !== -1) {
    event.preventDefault()
    const index = links.indexOf(link)
    options.index = index
    const gallery = new PhotoSwipe(photoswipeEl, PhotoSwipeUI_Default, images, options);
    gallery.init();
  }
})



/** WEBPACK FOOTER **
 ** ./src/js/main.js
 **/